import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeHe from '@angular/common/locales/he';
import { ErrorHandler, LOCALE_ID, ModuleWithProviders, NgModule } from '@angular/core';
import { ERRORS_CONFIG, ErrorsModule } from '@partners/errors';
import {
  DefaultErrorHandler,
  HttpCommonModule,
  MOCK_CONFIG,
  MockModule,
  endpointInterceptor,
  loaderInterceptor,
  remoteErrorInterceptor
} from '@partners/kernel';
import { IGlobalSettings, provideShellSettings } from '@partners/settings';
import { ShellStateModule, StateModule } from '@partners/state';
import { THEMES_CONFIG, ThemesModule } from '@partners/themes';
import { UiModule } from '@partners/ui';
import { DateUtilModule } from '@partners/utils';
import { ShellErrorsConfig, ShellMockConfig, ShellThemeConfig } from './config';

@NgModule({
  providers: [
    { provide: ErrorHandler, useClass: DefaultErrorHandler },
    { provide: LOCALE_ID, useValue: 'he' }
  ],
  imports: [
    UiModule,
    StateModule,
    ShellStateModule,
    HttpCommonModule,
    DateUtilModule.forRoot({
      format: 'DD/MM/YYYY',
      locale: 'he-IL'
    }),
    ErrorsModule.forRoot({
      provide: ERRORS_CONFIG,
      useClass: ShellErrorsConfig
    }),
    MockModule.forRoot({
      provide: MOCK_CONFIG,
      useClass: ShellMockConfig
    }),
    ThemesModule.forRoot({
      provide: THEMES_CONFIG,
      useClass: ShellThemeConfig
    })
  ]
})
export class FeatureShellModule {
  public static forRoot(shellSettings: IGlobalSettings): ModuleWithProviders<FeatureShellModule> {
    registerLocaleData(localeHe);
    return {
      ngModule: FeatureShellModule,
      providers: [
        provideShellSettings(shellSettings),
        provideHttpClient(withInterceptors([remoteErrorInterceptor, endpointInterceptor, loaderInterceptor]))
      ]
    };
  }
}
